import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";

export function BookOfMindToolAction({
    children,
    fullWidth = false,
}: {
    children: React.ReactNode;
    fullWidth?: boolean;
}) {
    return (
        <span
            className={StyleClass(
                `bookOfMindToolAction_${fullWidth ? "fullWidth" : "compact"}`,
                {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gridColumn: fullWidth ? "1 / -1" : undefined,
                    width: fullWidth ? "100%" : undefined,
                    minWidth: 0,
                    minHeight: fullWidth ? "34px" : "29px",
                    padding: fullWidth ? "4px 0 2px" : "2px 4px",
                    borderRadius: fullWidth ? 0 : "3px",
                    background: fullWidth
                        ? "transparent"
                        : "rgba(255, 255, 255, 0.035)",
                    border: fullWidth
                        ? "0"
                        : "1px solid rgba(143, 107, 55, 0.16)",
                    boxSizing: "border-box",
                    opacity: fullWidth ? 1 : 0.82,
                    color: "rgba(235, 230, 211, 0.88)",
                    whiteSpace: "nowrap",
                    overflow: fullWidth ? "visible" : "hidden",
                    transition:
                        "background 120ms ease, border-color 120ms ease, color 120ms ease",
                    "& > span": {
                        margin: 0,
                        width: fullWidth ? "100%" : undefined,
                        textAlign: fullWidth ? "center" : undefined,
                    },
                    "& > span > span": {
                        margin: fullWidth ? 0 : undefined,
                    },
                    ":hover": fullWidth
                        ? undefined
                        : {
                              background: "rgba(173, 139, 62, 0.18)",
                              borderColor: "rgba(173, 139, 62, 0.34)",
                              color: "rgba(245, 226, 164, 0.98)",
                          },
                    ":active": fullWidth
                        ? undefined
                        : {
                              background: "rgba(0, 0, 0, 0.3)",
                              borderColor: "rgba(143, 107, 55, 0.28)",
                          },
                }
            )}
        >
            {children}
        </span>
    );
}
